// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"CustomTypeControlList_actionsWrapper__3PvQH"};